import { useAuth } from '@/contexts/AuthContext';

/**
 * Whether the active workgroup's current package (subscription tier)
 * entitles `action` on `module`. Backed by AuthContext's `entitlements`
 * array, sourced from GET /auth/login-info (see
 * EntitlementService.getEffectiveEntitlements on the backend).
 *
 * Independent of role -- a Community-tier Owner can still fail this even
 * though useHasPermission passes. Gate UI on useCanAccess (which ANDs the
 * two) rather than this alone, unless you specifically want a plan-only check.
 */
export function useEntitlement(module: string, action: string): boolean {
  const { hasEntitlement } = useAuth();
  return hasEntitlement(module, action);
}

export default useEntitlement;
